<template>
	<div class="stories-lane l-content-section">
		<SectionTitle
			title="Social"
		/>
		<Carousel :cells="processSocialPosts(socialPosts)">
			<template #cell="{cell}">
				<a
					class="stories-lane__el l-carousel-wrapper-event"
					:class="[`-instagram`, {'has-image': cell.image_url}]"
					:href="cell.href"
					target="_blank"
					rel="noopener noreferrer"
				>
					<div class="stories-lane__el-inner-w">
						<div class="stories-lane__header">
							<div class="stories-lane__meta">
								<svg class="stories-lane__author-image">
									<use href="#sprite-logo-instagram-filled" />
								</svg>
								<div class="stories-lane__author">
									{{ cell.username }}
								</div>
								<div class="stories-lane__date">
									{{ cell.date }}
								</div>
							</div>

							<!-- eslint-disable vue/no-v-html -->
							<div
								v-if="cell.description"
								class="stories-lane__content s-html -xs"
								v-html="cell.description"
							/>
						</div>
						<div
							v-if="cell.image_url"
							class="stories-lane__image-w"
						>
							<div class="stories-lane__image-w-inner">
								<img
									class="stories-lane__image"
									:src="$Helpers.getScaledImageUrl(cell.image_url, 360)"
								>
							</div>
						</div>
					</div>
				</a>
			</template>
		</Carousel>
	</div>
</template>

<script>
import Carousel from '@js/components/Carousel';
import SectionTitle from '@js/components/SectionTitle';
import { getDateTime } from '@shared/utils/timeUtils';

export default {
	name:       'SocialLane',
	components: { Carousel, SectionTitle },
	props:      {
		socialPosts: {
			type:    Array,
			default: () => [],
		},
	},
	methods: {
		processSocialPosts(posts) {
			return posts.map((post) => ({
				...post,
				date: getDateTime(new Date(post.created_at).getTime() / 1000, { withTime: false }),
			}));
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.stories-lane__el {
	width: 274px + $sp4 !important; // stylelint-disable-line
	height: 512px + $sp4;
	display: block;

	// &.-story {}
	// &.-tweet {}
}

// .stories-lane__loading {}

.stories-lane__el-inner-w {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background-color: var(--color-grey-950);
	color: var(--color-grey-050);
	height: 100%;
	border-radius: var(--t-border-radius-card--lg);
	transition: transform $trans-time-fast;
	will-change: transform;
	overflow: hidden;

	body.-t-oeoc & { // stylelint-disable-line
		background-color: var(--color-grey-900);
	}

	@media (hover:hover) {
		&:hover {
			transform: scale(1.05);
		}
	}
}

.stories-lane__header {
	padding: $sp4;
	flex-shrink: 0;
	overflow: hidden;
}

.stories-lane__meta {
	display: flex;
	align-items: center;
	gap: $sp3;
	justify-content: space-between;
	margin-bottom: $sp5;
}

.stories-lane__date {
	@include font(primary, light, normal, fs-60);
	font-size: 10px; // stylelint-disable-line
	margin-left: auto;
	white-space: nowrap;
}

.stories-lane__title {
	@include font(primary, bold, normal, fs-100);
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box; // stylelint-disable-line value-no-vendor-prefix
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical; // stylelint-disable-line property-no-vendor-prefix
}

.stories-lane__content {
	@include font(primary, book, normal, fs-60);
	font-size: 12px !important; // stylelint-disable-line
	color: var(--color-grey-050) !important; // stylelint-disable-line declaration-no-important
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: pre-wrap;
	display: -webkit-box; // stylelint-disable-line value-no-vendor-prefix
	-webkit-line-clamp: 16;
	-webkit-box-orient: vertical; // stylelint-disable-line property-no-vendor-prefix

	.stories-lane__el.has-image & {
		-webkit-line-clamp: 7;
	}
}

.stories-lane__author-image {
	width: $sp4;
	height: $sp4;
}

.stories-lane__author {
	@include font(primary, medium, normal, fs-60);
}

.stories-lane__image-w {
	padding: 0 $sp4;
	// flex-grow: 1;
	overflow: hidden;
	align-items: center;
	display: flex;
}

.stories-lane__image-w-inner {
	aspect-ratio: 4 / 5;
	width: 100%;
	overflow: hidden;
	border-top-left-radius: $border-radius--md;
	border-top-right-radius: $border-radius--md;
}

.stories-lane__image {
	object-fit: cover;
	width: 100%;
	height: 100%;
	// scaled down images look over sharpened on non high resolution displays, so we blur them a bit
	@media (max-resolution: 1dppx) {
		filter: blur(0.5px);
	}
}
</style>
